import { TranslationObject } from "@ngx-translate/core";

const ENGLISH_LABELS = {
  label: "Breadcrumb",
  dashboard: "Dashboard",
  back: "Back to parent page",
  expand: "Show all ancestors",
};

const GERMAN_LABELS = {
  label: "Brotkrumennavigation",
  dashboard: "Dashboard",
  back: "Zurück zur übergeordneten Seite",
  expand: "Alle übergeordneten Seiten anzeigen",
};

export function withBreadcrumbTranslations(
  translations: TranslationObject,
  language: string,
): TranslationObject {
  const overrides: unknown = translations["coremediaBreadcrumb"];
  if (
    overrides !== undefined &&
    (overrides === null ||
      typeof overrides !== "object" ||
      Array.isArray(overrides) ||
      Object.values(overrides).some((value) => typeof value !== "string"))
  ) {
    throw new Error("Invalid coremediaBreadcrumb translation namespace");
  }

  const defaults =
    language.toLowerCase().split(/[-_]/)[0] === "de"
      ? GERMAN_LABELS
      : ENGLISH_LABELS;
  return {
    ...translations,
    coremediaBreadcrumb: { ...defaults, ...(overrides ?? {}) },
  };
}
